module.exports = __webpack_public_path__ + "img/ten_item_bg2.07316551.png";